import React, { useEffect } from 'react';

import { useCreditCardForm } from 'models/user';
import { useModal } from 'models/modal';

import Button from 'components/atoms/Button';
import { PaymentSDK } from 'components/atoms/PaymentSDK';

import { getPrime } from 'util/newebPay';

import styles from './index.css';

const { NEWEBPAY_HASHKEY } = process.env;

const Edit = ({ isFromApp = false, close = () => {} }) => {
	const [{ loading: formLoading }, { updateForm, sendCreditCard, clearForm }] = useCreditCardForm();
	const [, { openModal }] = useModal();

	const onSubmit = async () => {
		const env = process.env.NODE_ENV === 'development' ? 'test' : 'production';
		const prime = await getPrime(env, NEWEBPAY_HASHKEY);

		if (prime.error) {
			openModal({
				category: 'toast',
				type: 'failed',
				data: { message: prime.message },
			});
		} else {
			updateForm({
				type: 'creditCardForm',
				key: 'prime',
				data: { value: prime.value },
			});

			// 如果是 APP 的話，直接到轉 credit-card 頁面不打 API
			if (isFromApp) {
				close({ prime: prime.value });
			} else {
				sendCreditCard().then(({ value }) => {
					if (value.success) {
						close({ prime: prime.value });
					}
				});
			}
		}
	};

	useEffect(() => {
		clearForm('creditCardForm');
	}, []);

	return (
		<div className={styles.editWrapper}>
			<div className={styles.inputGroup}>
				<div>
					<PaymentSDK />
				</div>
				<div className={styles.actionButtonGroup}>
					<Button size="large" color="primary" disabled={formLoading} onClick={onSubmit}>
						完成
					</Button>
				</div>
				<div className={styles.actionButtonGroup}>
					<Button size="large" variant="outlined" color="primary" onClick={close}>
						返回
					</Button>
				</div>
			</div>
		</div>
	);
};

export default Edit;
